import * as React from 'react';
import { IconActionChevronRight12 } from '@cian/ui-kit-design-tokens/icons';
import * as style from './styles.css';
import { IBreadcrumbs } from '../../types/newbuilding/breadcrumbs';
import { Layout } from '../Layout';

export interface IBreadCrumbsProps {
  breadcrumbs: IBreadcrumbs[];
}

export class BreadCrumbs extends React.PureComponent<IBreadCrumbsProps> {
  public render() {
    const { breadcrumbs } = this.props;

    if (!breadcrumbs.length) {
      return null;
    }

    return (
      <div className={style['container']} aria-label="Ссылки на поиск по квартирам">
        <Layout stretch={true}>
          {breadcrumbs.map((crumb, index) => {
            const fullUrl = crumb.fullUrl || '/';
            const title = crumb.title || 'Ссылка';

            return (
              <React.Fragment key={fullUrl}>
                {index === 0 ? null : (
                  <span className={style['arrow']}>
                    <IconActionChevronRight12 color="white_60" />
                  </span>
                )}
                <a className={style['crumb']} href={fullUrl} title={title}>
                  {title}
                </a>
              </React.Fragment>
            );
          })}
        </Layout>
      </div>
    );
  }
}
